<template lang="pug">
  .b-invitation-list
    ._item(v-for="item in items" :title="item.isSent ? 'Приглашение отправлено' : 'Приглашение еще не отправлено'")
      Icon._icon(:name="item.isSent ? 'checked-true' : 'checked-false'")
      ._email {{ item.email }}
      ._delete(@click="$emit('delete', item)")
</template>

<script>
export default {
  name: 'InvitationList',
  props: {
    items: Array,
  },
};
</script>

<style scoped lang="scss">
  .invitation-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    &__item {
      padding: 12px;
      background: #F8F9FC;
      display: flex;
      gap: 15px;
      align-items: center;
      border-radius: 6px;
    }

    &__email {
      cursor: default;
    }

    &__icon {
      width: 20px;
      height: 20px;
    }

    &__delete {
      width: 10px;
      height: 10px;
      position: relative;
      cursor: pointer;

      &:before, &:after {
        position: absolute;
        top: 50%;
        left: 0;
        display: block;
        content: '';
        width: 100%;
        height: 1.5px;
        background: #1E3147;
      }

      &:before { transform: rotate(45deg); }
      &:after { transform: rotate(-45deg); }
    }

    @media (max-width: 550px) {
      &__item {
        width: 100%;
      }

      &__delete {
        margin-left: auto;
      }
    }
  }
</style>
